import axios from 'axios';

export const fetchHotkeyActions = async () => axios.get(`hotkey/actions`);

export const fetchHotkeys = async (hallId: number = 0, tableId: number = 0) => axios.get(`hotkeys/${hallId}/${tableId}`);

export const fetchAddHotkey = async (key: string, actionId: number, hallId: number = 0, tableId: number = 0) => axios.post(`hotkey/${key}/${actionId}/${hallId}/${tableId}`);

export const fetchRemoveHotkey = async (hotkeyId: number) => axios.delete(`hotkey/${hotkeyId}`);
